const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

export const savePostLoginRedirect = () => {
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, globalThis.location.hash);
};

export const handlePostLoginRedirect = (): boolean => {
  const redirectPath = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  if (redirectPath) {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    const cleaned = globalThis.location.pathname + redirectPath;
    globalThis.location.replace(cleaned);

    return true;
  }
  return false;
};
